import { InfoPlateVariant } from "fe-shared/src/components";
import { TransactionStatus, TransferStatus } from "../types";

export type TransactionStatusesConfigMap = {
  [key in TransactionStatus]?: InfoPlateVariant;
};

export type TransferStatusesConfigMap = {
  [key in TransferStatus]?: InfoPlateVariant;
};

export const TRANSACTION_STATUSES_CONFIG_MAP: TransactionStatusesConfigMap = {
  [TransactionStatus.Submitted]: "neutral",
  [TransactionStatus.Suspended]: "purple",
  [TransactionStatus.InReview]: "warning",
  [TransactionStatus.Approved]: "active",
  [TransactionStatus.Reviewed]: "orange",
  [TransactionStatus.Invalid]: "error",
  [TransactionStatus.Invoiced]: "info",
  [TransactionStatus.Synchronizing]: "orange",
  [TransactionStatus.Initiated]: "neutral",
};

export const TRANSFER_STATUSES_CONFIG_MAP: TransferStatusesConfigMap = {
  [TransferStatus.Approved]: "active",
  [TransferStatus.Submitted]: "neutral",
  [TransferStatus.InReview]: "warning",
  [TransferStatus.Invoiced]: "info",
  [TransferStatus.Invalid]: "error",
};
